export const PAGE_NOTE = "Ops sends your contract to each of your publishers. Sign them one by one or all at once — each publisher can sign theirs once you have.";

export const PUBLISHER_NOTE = "A publisher stays payout-ineligible until their KYC is verified and they have signed a contract. Anyone who signed an earlier version keeps receiving payouts while a new one is pending.";

export const PUBLISHER_TIME_COPY = {
    signed : "Signed",
    sent   : "Sent",
    notSent: "Not sent yet"
};

export const SIGN_COPY = {
    review          : "Review & sign",
    signing         : "Signing…",
    all             : "Sign all",
    nothingToSign   : "No contracts are waiting for your signature",
    allConfirmTitle : (count) => `Sign ${count} contract${count === 1 ? "" : "s"}?`,
    allConfirmText  : "Every contract waiting for your signature is signed in your name. Each publisher can then sign theirs. This cannot be undone.",
    allConfirmButton: "Sign all",
    signed          : "Contract signed.",
    // `queued` / `failed` from the sign-all response.
    allResult       : ({ queued = 0, failed = 0 }) => [
        `${queued} contract${queued === 1 ? "" : "s"} queued for signing`,
        failed ? `${failed} failed — try again` : ""
    ].filter(Boolean).join(" · "),
    failure: "Could not sign. Please try again."
};

// "3 of 8 publishers have signed."
export const signedSummary = ({ signed = 0, total = 0 }) => `${signed} of ${total} publisher${total === 1 ? "" : "s"} have signed.`;
